/**
 * ProfilePageSkeleton - Loading skeleton for ProfilePage
 * Provides a full-page skeleton that matches the ProfilePage layout
 */

import { Skeleton } from './LoadingSpinner';

export function ProfilePageSkeleton() {
  return (
    <div
      className="min-h-screen bg-gray-50 dark:bg-gray-900"
      role="status"
      aria-label="Loading profile page"
    >
      {/* Header Skeleton */}
      <header className="bg-white dark:bg-gray-800 shadow-sm border-b border-gray-200 dark:border-gray-700">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center py-6">
            <div>
              <Skeleton className="h-8 w-64 mb-2" />
              <Skeleton className="h-4 w-80" />
            </div>
            <Skeleton className="h-10 w-40 rounded-lg" />
          </div>
        </div>
      </header>

      {/* Main Content Skeleton */}
      <main className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <div className="space-y-8">
          {/* Profile Form Card Skeleton */}
          <div className="card">
            <div className="card-header">
              <Skeleton className="h-6 w-48 mb-2" />
              <Skeleton className="h-4 w-96" />
            </div>

            <div className="card-content space-y-6">
              {/* Avatar Section Skeleton */}
              <div className="flex flex-col sm:flex-row items-center sm:space-x-6 space-y-4 sm:space-y-0">
                <Skeleton className="h-20 w-20 rounded-full" />
                <div className="flex-1 text-center sm:text-left">
                  <Skeleton className="h-5 w-32 mb-2" />
                  <Skeleton className="h-4 w-64 mb-3" />
                </div>
              </div>

              {/* Display Name Field Skeleton */}
              <div>
                <Skeleton className="h-4 w-32 mb-2" />
                <Skeleton className="h-10 w-full rounded-lg" />
                <Skeleton className="h-4 w-48 mt-2" />
              </div>

              {/* Legal Name Field Skeleton */}
              <div>
                <Skeleton className="h-4 w-40 mb-2" />
                <Skeleton className="h-10 w-full rounded-lg" />
                <Skeleton className="h-4 w-64 mt-2" />
              </div>

              {/* Account Information Section Skeleton */}
              <div className="border-t border-gray-200 dark:border-gray-700 pt-6">
                <Skeleton className="h-6 w-48 mb-4" />
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                  <div>
                    <Skeleton className="h-4 w-32 mb-2" />
                    <Skeleton className="h-10 w-full rounded-lg" />
                    <Skeleton className="h-4 w-64 mt-2" />
                  </div>
                  <div>
                    <Skeleton className="h-4 w-40 mb-2" />
                    <Skeleton className="h-10 w-full rounded-lg" />
                    <Skeleton className="h-4 w-80 mt-2" />
                  </div>
                </div>
              </div>
            </div>

            <div className="card-footer flex justify-between">
              <Skeleton className="h-10 w-24 rounded-lg" />
              <Skeleton className="h-10 w-32 rounded-lg" />
            </div>
          </div>

          {/* Additional Settings Card Skeleton */}
          <div className="card">
            <div className="card-header">
              <Skeleton className="h-6 w-48 mb-2" />
              <Skeleton className="h-4 w-64" />
            </div>
            <div className="card-content">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <Skeleton className="h-24 w-full rounded-lg" />
                <Skeleton className="h-24 w-full rounded-lg" />
              </div>
            </div>
          </div>
        </div>
      </main>
    </div>
  );
}
